import React from "react";
import Modal from "../masters/Modal";
import DatePicker from "../../Common/DatePicker";
import { parsePayMonthValue, payMonthToDatePickerValue } from "./statutoryPayMonthUtils";

export default function StatutoryMaternityModal({
  isOpen,
  onClose,
  darkMode,
  maternityDraft,
  setMaternityDraft,
  employees,
  onSave,
}) {
  const inputClass =
    "h-9 w-full rounded-md border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-2 text-xs";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={onSave}
      submitText="Save details"
      title="Form A — Maternity benefit details (Sections 6–10)"
      maxWidthClass="max-w-3xl"
    >
      <div className="grid gap-3 md:grid-cols-2">
        <div>
          <label className="ds-caption mb-1 block">Female employee</label>
          <select
            className={inputClass}
            value={maternityDraft.employeeId}
            onChange={(e) => setMaternityDraft((p) => ({ ...p, employeeId: e.target.value }))}
          >
            <option value="">Select employee</option>
            {employees
              .filter((e) => String(e.user?.gender || "").toLowerCase().startsWith("f"))
              .map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {emp.empCode} — {[emp.user?.name, emp.user?.lastName].filter(Boolean).join(" ")}
                </option>
              ))}
          </select>
        </div>
        <div>
          <DatePicker
            monthYearOnly
            showMonthName
            label="Pay month"
            value={payMonthToDatePickerValue(maternityDraft.payMonth)}
            onChange={(e) =>
              setMaternityDraft((p) => ({
                ...p,
                payMonth: parsePayMonthValue(e.target.value),
              }))
            }
            darkMode={darkMode}
          />
        </div>
        <DatePicker label="S.6 Notice date" value={maternityDraft.noticeDateSection6 || ""} onChange={(e) => setMaternityDraft((p) => ({ ...p, noticeDateSection6: e.target.value }))} darkMode={darkMode} />
        <DatePicker label="Child birth date" value={maternityDraft.childBirthDate || ""} onChange={(e) => setMaternityDraft((p) => ({ ...p, childBirthDate: e.target.value }))} darkMode={darkMode} />
        <DatePicker label="Advance benefit date" value={maternityDraft.advanceBenefitDate || ""} onChange={(e) => setMaternityDraft((p) => ({ ...p, advanceBenefitDate: e.target.value }))} darkMode={darkMode} />
        <input type="number" className={inputClass} placeholder="Advance benefit amount" value={maternityDraft.advanceBenefitAmount || ""} onChange={(e) => setMaternityDraft((p) => ({ ...p, advanceBenefitAmount: e.target.value }))} />
        <DatePicker label="Subsequent payment date" value={maternityDraft.subsequentPaymentDate || ""} onChange={(e) => setMaternityDraft((p) => ({ ...p, subsequentPaymentDate: e.target.value }))} darkMode={darkMode} />
        <input type="number" className={inputClass} placeholder="Subsequent payment amount" value={maternityDraft.subsequentPaymentAmount || ""} onChange={(e) => setMaternityDraft((p) => ({ ...p, subsequentPaymentAmount: e.target.value }))} />
        <input className={`${inputClass} md:col-span-2`} placeholder="Remarks" value={maternityDraft.remarks || ""} onChange={(e) => setMaternityDraft((p) => ({ ...p, remarks: e.target.value }))} />
      </div>
    </Modal>
  );
}
